let language = {
    // store-status
    STORE_ORDERS_ALL_STORE: "All",
    STORE_ORDERS_STORE_LABEL_NAME: "Store:",

    // btn-send-to
    STORE_ORDERS_BTN_SEND_TO: "SEND TO",
    
    // store-orders-search/filter/sort
    STORE_ORDERS_FILTER_ORDER_DATE: "Order Dates:",
    STORE_ORDERS_SEARCH_INPUT_PLACEHOLDER: "Search Orders",

    // header
    STORE_ORDERS_HEADER_ORDER_NUMBER: "Order No.",
    STORE_ORDERS_HEADER_DATE: "Date",
    STORE_ORDERS_HEADER_ORDER_STATUS: "Order Status",
    STORE_ORDERS_HEADER_SUBMITTED_TO: "Submitted to",
    STORE_ORDERS_HEADER_RETAIL_TOTAL: "Retail Total",

    // content
    STORE_ORDERS_CONTENT_SUBMITTED_STATUS_PAID: "paid:",
    STORE_ORDERS_CONTENT_SUBMITTED_STATUS_UNPAID: "unpaid:",
    STORE_ORDERS_CONTENT_IS_ORDERED: "submitted",
    STORE_ORDERS_AUTHORIZATION_ALREADY: "Your authorization has expired. Please",
    STORE_ORDERS_AUTHORIZATION_WILL: "Your authorization is about to expired. Please",
    STORE_ORDERS_ORDERED_REAUTHORIZE: "reauthorize",
    STORE_ORDERS_ORDERED_YOUR_ACCOUNT: "your account.",
};

export { language }